import React from 'react'
import {Link} from 'react-router-dom'
import hback from '../Image/hback.avif'
import { GrCatalog } from "react-icons/gr";
import Fade from 'react-reveal/Fade';
import TypeWriter from '../Page/TypeWriter';
const typeWriter = ["Data Science", "Machine Learning", "Web Development", "Java", "Cloud Computing"];
function Home_page() {
  return (
    <div>

      {/* ------------------------Mobile View--------------------------------- */}
      <div className='container_fluid background d-sm-block d-md-none pb-4 pt-5 mt-4'>
        <div className='container-fluid'>
        <div className='row'>
          <Fade left>
            <div className='col-md-12 pt-2'>
                <div className=''>
                  <h4 className='display-5'>Transform Your Future With InternsElite</h4>
                  <p className='fs-2 pt-2 fw-bold home_page_text'>Whether its <TypeWriter data={typeWriter} /></p>
                  <div className='home_border mb-2'></div>
                  <p className='mobile_home_pera_text'>We offer modern training that can help you improve your abilities and open doors to exciting new possibilities. It's time to start feeding your success. </p>
                </div>
            </div>
          </Fade>
            <div className='col-md-12 mt-3'>
            <img  className='mobile_home_background_img' src={hback}  />
            </div>
        </div>
        </div>
        {/* <div className=''>
            <div className='container home_button_text mt-3'>
              <div className='row'>
                <div className='col-sm-4'>
                <div className='d-flex justify-content-center py-3'>
                <Link to="/ML"><button className="text-dark border home_page_button homw_button btn ">
                    <div className='row px-4'>
                    <div className='col-4 pt-2'><GrCatalog size="50px" color="black" className='d-inline'/></div>
                    <div className='col-8 pt-2'>
                      <span>Build A Career In</span>
                      <p>Machine Learning</p>
                    </div>
                    </div>
                </button></Link>
                </div>
                </div>
                <div className='col-sm-4'>
                <div className='d-flex justify-content-center py-3'>
                  <Link to="/DS">
                  <button className="text-dark border home_page_button  homw_button btn ">
                    <div className='row px-4'>
                    <div className='col-4 pt-2'><GrCatalog size="50px" color="black" className='d-inline'/></div>
                    <div className='col-8 pt-2'>
                      <span>Build A Career In</span>
                      <p>Data Science</p>
                    </div>
                    </div>
                  </button></Link>
                </div>
                </div>
                <div className='col-sm-4'>
                <div className='d-flex justify-content-center py-3'>
                  <Link to="/CC">
                  <button className="text-dark border home_page_button  homw_button btn">
                      <div className='row px-4'>
                      <div className='col-4 pt-2'><GrCatalog size="50px" color="black" className='d-inline'/></div>
                      <div className='col-8 pt-2'>
                        <span>Build A Career In</span>
                        <p>Cloud Computing</p>
                      </div>
                      </div>
                  </button></Link>
                  </div>
                </div>
              </div>
            </div>
        </div> */}
      </div>

      {/* ---------------------------Tab View--------------------------- */}

      {/* <div className='container_fluid background d-none d-lg-none d-md-block pb-5 pt-5'>
        <div className='container'>
        <div className='row pt-4'>
        <Fade left>
          <div className='col-md-6'>
                <h6 className='display-5'>Hello Folks !</h6>
                <p className='display-5 pt-2 fw-bold home_page_text'>Want to Learn New Technologies</p>
                <div className='home_border mb-3'></div>
                <p className='tab_home_pera_text'>You want results. We have found that the best way to get them is with up front research – of your Feild, Right Domians, target setting and desire to rule. Only after we fully understand you and we recommend a plan of attack.</p>
          </div>
        </Fade>
        <Fade right>
          <div className='col-md-6 '>
          <img  className='tab_home_background_img' src={hback}  />
          </div>
        </Fade>
        </div>
        </div>
      </div> */}

      {/* -----------------------Desktop View--------------------------------- */}
      <div className='container_fluid background d-none d-lg-block pb-5 pt-5'>
        <div className='container pt-5'>
        <div className='row pt-3'>
        <Fade left>
          <div className='col-md-7 pt-3'>
                <h4 className='display-5 mt-5'>Transform Your Future With InternsElite</h4>
                <p className='display-6 py-2 fw-bold home_page_text'>Whether its <TypeWriter data={typeWriter} /></p>
                <div className='home_border mb-4'></div>
                <p className='home_pera_text fs-5'>We offer modern training that can help you improve your abilities and open doors to exciting new possibilities. It's time to start feeding your success. </p>
          </div>
        </Fade>
        <Fade right>
          <div className='col-md-5 pt-4'>
          <img  className='home_background_img' src={hback}  />
          </div>
        </Fade>
        </div>
        </div>
        {/* <div className=''>
            <div className='container home_button_text'>
              <div className='row'>
                <div className='col-sm-4'>
                <div className='d-flex justify-content-center py-3'>
                <Link to="/DS">
                <button className="text-dark border home_page_button homw_button btn ">
                    <div className='row px-3'>
                    <div className='col-4 pt-2'><GrCatalog size="50px" color="black" className='d-inline'/></div>
                    <div className='col-8 pt-2'>
                      <span>Build A Career In</span>
                      <p>Data Science</p>
                    </div>
                    </div>
                </button></Link>
                </div>
                </div>
                <div className='col-sm-4'>
                <div className='d-flex justify-content-center py-3'>
                  <Link to="/ML">
                  <button className="text-dark border home_page_button  homw_button btn ">
                    <div className='row px-3'>
                    <div className='col-4 pt-2'><GrCatalog size="50px" color="black" className='d-inline'/></div>
                    <div className='col-8 pt-2'>
                      <span>Build A Career In</span>
                      <p>Machine Learning</p>
                    </div>
                    </div>
                  </button></Link>
                </div>
                </div>
                <div className='col-sm-4'>
                <div className='d-flex justify-content-center py-3'>
                  <Link to="/CC">
                  <button className="text-dark border home_page_button  homw_button btn">
                      <div className='row px-3'>
                      <div className='col-4 pt-2'><GrCatalog size="50px" color="black" className='d-inline'/></div>
                      <div className='col-8 pt-2'>
                        <span>Build A Career In</span>
                        <p>Cloud Computing</p>
                      </div>
                      </div>
                  </button></Link>
                </div>
                </div>
              </div>
            </div>
        </div> */}
      </div>
    </div>
  )
}

export default Home_page
